import React from 'react';

interface IdentityIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export const IdentityIcon: React.FC<IdentityIconProps> = ({ size = 20, ...props }) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      height={size}
      width={size}
    >
      <path
        clipRule="evenodd"
        d="M4.563 2.86a4.076 4.076 0 0 1 5.764 0l-.474.475.474-.474a4.076 4.076 0 0 1-5.764 5.764 4.076 4.076 0 0 1 0-5.764Zm2.882.148a2.735 2.735 0 0 0-1.934 4.669m0 0a2.735 2.735 0 0 0 3.868 0l.474.474-.474-.474a2.735 2.735 0 0 0 0-3.868l.472-.473-.472.473a2.735 2.735 0 0 0-1.934-.801m5.31-.727a.67.67 0 0 1 .816-.483 4.076 4.076 0 0 1 0 7.898.67.67 0 0 1-.332-1.3 2.735 2.735 0 0 0 0-5.299.67.67 0 0 1-.484-.816ZM5.742 13.226a2.735 2.735 0 0 0-2.735 2.735v1.703a.67.67 0 0 1-1.341 0V15.96c0-1.081.43-2.118 1.194-2.882m0 0a4.076 4.076 0 0 1 2.882-1.194h3.406a4.076 4.076 0 0 1 4.076 4.076v1.703a.67.67 0 0 1-1.34 0V15.96a2.735 2.735 0 0 0-2.735-2.735H5.74m8.717-.71a.67.67 0 0 1 .816-.482 4.077 4.077 0 0 1 3.057 3.923v1.707a.67.67 0 0 1-1.34 0v-1.701a2.735 2.735 0 0 0-2.052-2.63.67.67 0 0 1-.481-.818Z"
        fill="#B5BCC4"
        fillRule="evenodd"
      />
    </svg>
  );
};
